<template>
    <div
        class="flex flex-col p-4 flex-1 min-h-0 gap-6 border-t-4"
        :class="isActive ? 'border-green-600 bg-card' : 'border-transparent opacity-50 bg-black'"
    >
        <SegmentPlayerCard :player="player" :is-active="isActive" />
        <div class="flex-1 grid grid-cols-2 items-center w-full overflow-hidden">
            <SegmentsCurrentTargetText
                :target-segment="projection.target"
                :target-hits="projection.hits"
                :hits-per-target="hitsPerTarget"
                :segments="segments"
                :current-index="projection.index"
            />
            <SegmentsDartboard
                :active-segment="projection.target"
                :next-segment="segments[projection.index + 1] || null"
                :third-segment="segments[projection.index + 2] || null"
                class="h-full w-full block"
            />
        </div>
        <div class="grid grid-cols-2">

            <SegmentsCompletedCount
                :completed="Math.min(projection.index, segments.length)"
                :total="segments.length"
                :inline="true"
            />
            <SegmentsAccuracy
                :segments="segments"
                :darts-submitted="dartsSubmitted"
                :entered-darts="enteredDarts"
                class="justify-end"
            />
        </div>
    </div>
</template>

<script>
import SegmentsDartboard from '@/components/games/segments/SegmentsDartboard.vue'
import SegmentPlayerCard from '@/components/games/segments/SegmentsPlayerCard.vue'
import SegmentsCurrentTargetText from '@/components/games/segments/SegmentsCurrentTargetText.vue'
import SegmentsCompletedCount from '@/components/games/segments/SegmentsCompletedCount.vue'
import SegmentsAccuracy from '@/components/games/segments/SegmentsAccuracy.vue'

export default {
    name: 'SegmentsVerticalPlayer',
    components: {
        SegmentsDartboard,
        SegmentPlayerCard,
        SegmentsCurrentTargetText,
        SegmentsCompletedCount,
        SegmentsAccuracy,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        // The player's ordered segment list (from their latest turn).
        segments: {
            type: Array,
            default: () => [],
        },
        // { index, hits, target } — where the player is in their segment list.
        projection: {
            type: Object,
            default: () => ({ index: 0, hits: 0, target: null }),
        },
        hitsPerTarget: {
            type: Number,
            default: 1,
        },
        // Darts thrown this leg, for accuracy.
        dartsSubmitted: {
            type: Number,
            default: 0,
        },
        // In-progress darts (active player only).
        enteredDarts: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
